import { createReducer } from '../../../utilities';
import {
    SUCCESS_FETCH_STATS_PLAYERS_VALUE
} from "../../../../actions/entities/statistics/players";

const initialState = {};

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        ...data,
    };
}

export default createReducer(initialState, {
    [SUCCESS_FETCH_STATS_PLAYERS_VALUE]: successFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/players/value.js